import React from 'react'
import Price from '../Price/Price'
import PriceDynamicCreditCopy from '../PriceDynamicCreditCopy/PriceDynamicCreditCopy'

import * as Styled from './PriceContainer.styles'
import { useFeatureFlagContext } from '@/javascript/providers/FeatureFlagContext/FeatureFlagContext'

const PriceContainer = ({ priceAttributes, creditPlans, ShowPaypalCreditOption, PAYPAL_IFC_MESSAGING }) => {
  const { PDP_V2_FLAG } = useFeatureFlagContext()

  return (
    <Styled.PriceContainer smallMargin={PDP_V2_FLAG}>
      <Price {...priceAttributes} ShowPaypalCreditOption={ShowPaypalCreditOption} creditPlans={creditPlans} />
      {PAYPAL_IFC_MESSAGING && (
        <PriceDynamicCreditCopy creditPlans={creditPlans} ShowPaypalCreditOption={ShowPaypalCreditOption} />
      )}
    </Styled.PriceContainer>
  )
}

export default PriceContainer
